import apiClient from '../../../api/apiClient';
import { ADMIN_REST_API_BASE_URL } from '../../../config';
const REST_API_BASE_URL = ADMIN_REST_API_BASE_URL;

export const getApp = (subid, appid) =>
  apiClient.get(`${REST_API_BASE_URL}/subscription/${subid}/app/${appid}`);

//@GetMapping("/myapps/{appCode}/availableItems")
export const getAllItemsForApp = (appId) =>
  apiClient.get(
    `${REST_API_BASE_URL}/subscription/app/${appId}/availableItems`,
  );

//@GetMapping("/myapps/selectedItems")
// export const getAllSelectedItemsByApp = (id) => apiClient.get(`${REST_API_BASE_URL}/parent/${id}/items`);
// export const getAllSelectedItemsByApp = () => apiClient.get(`${REST_API_BASE_URL}/myapps/selectedItems`);
export const getAllSelectedItemsByApp = (appid) =>
  apiClient.get(`${REST_API_BASE_URL}/subscription/app/${appid}/selectedItems`);

export const getSelectedItemsByLoggedInUserAndSubscription = (subid, appid) =>
  apiClient.get(
    `${REST_API_BASE_URL}/subscription/${subid}/app/${appid}/selectedItems`,
  );

//@PostMapping("/subscription/{subid}/item/{itemid}")
export const addItemToSubscription = (subid, itemid, item) =>
  apiClient.post(
    `${REST_API_BASE_URL}/subscription/${subid}/item/${itemid}`,
    item,
  );

//@DeleteMapping("/subscription/{subid}/item/{itemid}")
export const removeItemFromSubscription = (subid, itemid) =>
  apiClient.delete(`${REST_API_BASE_URL}/subscription/${subid}/item/${itemid}`);

export default apiClient;
